module.exports = __webpack_public_path__ + "static/media/menu-granel.f268c305.svg";